import { collection, getDocs } from "firebase/firestore";
import { db } from "./firebase";
import { Globals } from "../globals";
import { gemeindeSubPath } from "./gemeindePaths";
import { Absence, AbsenceMap, toIsoDay } from "../utils/absences";

/**
 * Loads the current and future absences of the given preachers. Absences are
 * entered by the preachers through their personal link; admins only read them.
 * Returns an empty map for users who may not read them (members).
 */
export async function loadAbsencesByPreacher(gemeindeId: string, preacherKeys: string[]): Promise<AbsenceMap> {
    const today = toIsoDay(new Date());
    const result: AbsenceMap = new Map();
    try {
        await Promise.all(
            preacherKeys.map(async (key) => {
                const snap = await getDocs(
                    collection(db, ...gemeindeSubPath(gemeindeId, Globals.PREACHER_SUBCOLLECTION, key, Globals.ABSENCES_SUBCOLLECTION))
                );
                const absences: Absence[] = snap.docs
                    .map((doc) => ({
                        id: doc.id,
                        from: String(doc.data().from ?? ""),
                        to: String(doc.data().to ?? ""),
                        note: String(doc.data().note ?? ""),
                    }))
                    .filter((absence) => absence.to >= today)
                    .sort((a, b) => a.from.localeCompare(b.from));
                if (absences.length > 0) result.set(key, absences);
            })
        );
    } catch {
        return new Map();
    }
    return result;
}
